// GENERIC STUFF
export const Generic = {
    back: 'Indietro',
    edit: 'Modifica'
};


// SCOPE OF THE PERSONAL DATA PAGE
export const PersonalDataPage = {
    progressionRow: { // TODO: fix me up
        title: 'change me',
        time: 'change me'
    },
    formTitle: 'Dati personali',
    formSubtitle: 'Inserisci i dati dell\'intestatario dell\'ultima bolletta.'
}


// SCOPE OF THE FORNITURE ADDRESS PAGE
export const ForniturePage = {
    progressionRow: {
        title: 'indirizzo di fornitura',
        time: '2 min'
    },
    formTitle: 'indirizzo fornitura',
    formSubtitle: 'Comunicaci dove vuoi attivare la fornitura.',
    powerPopupText: 'La potenza impegnata è stimata in funzione degli elettrodomestici presenti in casa. La ' +
        'potenza del contatore di un\'utenza domestica residente è di solito 3 kW ma potrebbero non ' +
        'essere sufficienti laddove in casa fossero presenti elettrodomestici energivori, come caldaia ' +
        'elettrica, forno elettrico, lavatrice.',
    annualGasPopupText: 'Verifica sulla fattura qual è il tuo consumo annuo. Tra i fattori più ' +
        'rilevanti che determinano la quantità di consumo gas ci sono ad esempio il numero dei ' +
        'componenti del nucleo familiare e le abitudini degli abitanti della casa.',
    annualEnergyPopupText: 'Verifica sulla fattura qual è il tuo consumo annuo, facendo attenzione ' +
        'a sommare i consumi delle fasce F1, F2,F3. Tra i fattori più rilevanti che determinano la quantità ' +
        'di consumo ci sono ad esempio il numero dei componenti del nucleo familiare  le abitudini degli ' +
        'abitanti della casa.',
};

// SCOPE OF THE RECAP PAYMENT PAGE
export const RecapPaymentPage = {
    progressionRow: {
        title: 'recapito e pagamento',
        time: '2 min'
    },
    formTitle: 'recapito e pagamento',
    formSubtitle: ''
};

export const ConsentPageI18n = {
    fastSwitchConditionsShort: 'Selezionando tale funzione stai chiedendo che il contratto abbia esecuzione prima che sia ' +
        'decorso il termine di ripensamento di 14 gg. Tale richiesta consente di ottenere la fornitura con ' +
        'il nuovo esercente con un certo anticipo rispetto alle normali tempistiche. ',
    fastSwitchConditions: 'Il Cliente mantiene in ogni caso il diritto di esercitare il ripensamento entro 14 gg. dalla conclusione del ' +
        ' contratto. Se il Cliente ha chiesto di iniziare la fornitura di energia elettrica e/o gas durante il periodo di ' +
        ' ripensamento e poi esercita comunque il ripensamento, è tenuto a pagare alla società di vendita gli importi ' +
        ' relativi ai costi sostenuti fino al momento in cui ha comunicato tale ripensamento rispetto a tutte le ' +
        ' prestazioni previste dal contratto, ed in particolare: i) qualora non sia stata avviata la fornitura, un ' +
        ' corrispettivo massimo non superiore al corrispettivo applicato dall’esercente la maggior tutela nei casi di cui ' +
        ' all’articolo 11 del TIV; ii) nel caso di avvio della fornitura, il cliente finale sarà tenuto al pagamento dei ' +
        ' corrispettivi previsti dal contratto fino al momento della cessazione della fornitura.',
    acceptContract: 'Il Cliente, consapevole delle conseguenze penali nel caso di false di dichiarazioni ex art. 46 e 76 del DPR 445/2000, dichiara: ',
    acceptContractA: 'a) di aver ricevuto antecedentemente alla sottoscrizione tutte le informazioni precontrattuali di cui agli ' +
        'articoli 48 e 49 DLgs. n. 206/2005 e di cui all’art. 9 della delibera ARERA ARG/com n. 366/18 e s. m e i.; ',
    acceptContractB: 'b) di aver ricevuto copia integrale del Contratto di fornitura gas naturale e/o energia elettrica, di averne ' +
        'letto attentamente le condizioni e, certificando la correttezza dei dati sopra indicati, di accettare quindi il ' +
        'presente Contratto e relativi allegati; ',
    acceptVessatorieTitle: 'Accettazione Clausole Vessatorie (ai sensi dell’art. 1341 e 1342 cod. civ)',
    acceptVessatorieText: 'Il Cliente dichiara di approvare in particolare, anche ai fini degli art.1341 e 1342 cod. civ., i ' +
        'seguenti articoli delle Condizioni Generali per la somministrazione di gas naturale e/o energia ' +
        'elettrica: 2 (uso del gas e/o dell’energia elettrica, esclusiva); 3 (mandati esclusivi); 4.1 ' +
        '(condizioni sospensive); 4.4 (recesso e penale); 5.1 (limitazione di responsabilità); 6 (forza ' +
        'maggiore); 8.2 (nuove condizioni e silenzio-assenso); 9.5 (sospensione e riduzione della ' +
        'somministrazione); 9.7 (oneri per la sospensione); 10 (garanzie); 11.2 (manleva e termine entro ' +
        'cui presentare la documentazione fiscale); 12 (clausola risolutiva espressa) 13.2 (variazioni ' +
        'unilaterali al Contratto); 13.4 (cessione del Contratto), 16.2 (riservatezza), 18 (foro ' +
        'competente). ',
    acceptFreeMarketTitle: 'Accettazione offerta a condizioni di mercato libero',
    acceptFreeMarketDescription: 'Il Cliente dichiara di aver scelto liberamente Vivigas energia quale controparte contrattuale ' +
        'nel mercato libero dell’energia elettrica e/o del gas naturale e di aver contrattato liberamente le ' +
        'condizioni di fornitura, ivi compresa la scelta delle Condizioni Generali e Particolari Economiche, ' +
        'dichiarando in particolare: ',
    acceptFreeMarketFirstEntry: 'di conoscere le condizioni economiche di cui all’Allegato A alla Delibera' +
        'dell\'Autorità ARG/gas 64/09 e s.m. e i., offerta da VIVIgas energia, e di aver optato ' +
        'per le diverse condizioni di cui al Contratto in quanto ritenute più favorevoli di quelle ' +
        'stabilite con Delibera ARERA 229/01; ',
    acceptFreeMarketSecondEntry: 'di conoscere le condizioni contrattuali standard o regolate dell’Autorità (in ' +
        'particolare le offerte PLACET di cui alla Delibera ARERA 555/17 e le condizioni ' +
        'inerenti la periodicità di fatturazione e l’ordine delle misure di cui agli art. 4.3, 5.3 e ' +
        '6.8 della Delibera ARERA 463/16), offerte da VIVIgas energia, e di aver optato per le ' +
        'diverse condizioni di cui al Contratto, in quanto ritenute più favorevoli. ',
}

export const RecapPageI18n = {
    legalNotesTitle: "Note legali ex DLgs 70/03.",
    supplier: "Fornitore: VIVIGAS S.P.A.",
    office: "25030 Roncadelle (BS), Via Vittorio Emanuele II, n. 4/28.",
    contacts: "Contatti: 800.151313 – 800.302233; mail: servizio.clienti@vivigas.it; www.vivigas.it.",
    iva: "REA e PIVA: BS- 439186 / C.F. e P.I. 13149000153",
    conduct: 'Codici di condotta: il contratto di fornitura di energia elettrica e/o gas rispetta il codice di condotta allegato ' +
        'alla Delibera 366/18 dell’Autorità Regolazione Energia Reti e Ambiente (ARERA) ed il Codice del Consumo ' +
        'per i contratti a distanza (D.lgs. n. 206/2005).',
    contractMode: 'Modalità di stipula del contratto: il contratto di fornitura di energia elettrica e/gas è stipulato con ' +
        "l’adesione del cliente, manifestata attraverso il completo inserimento dei dati e delle indicazioni richieste " +
        'nel form di adesione on line, sul sito www.vivigas.it  e selezionando "Conferma"',
    contractAvailability: 'Disponibilità documentazione contrattuale/Modalità di archiviazione e accesso alla documentazione ' +
        'contrattuale: il Cliente deve prendere visione della documentazione contrattuale all’interno del sito ' +
        'www.vivigas.it. Al termine della compilazione del form on line è tenuto a stampare e a conservare la ' +
        'documentazione contrattuale. Il contratto precompilato in tutte le sue parti con i dati forniti dal Cliente, ' +
        'sarà in ogni caso inviato per posta o via mail allo stesso e archiviato nei sistemi documentali di Vivigas. ',
}